import "@story/story_assets/dom_extend";

function updateMassive(category) {
	const inputs = document.querySelectorAll("[data-massive-action='" + category + "']");
	const targets = document.querySelectorAll("[data-massive='" + category + "']");

	const ids = Array.from(inputs).map(input => input.checked ? input.value : null).filter(Boolean).join(",");

	for (const target of targets) {
		target.value = ids;
	}
}

document.addEventSelectorListener("click", "[data-massive-toggle]", (event, target) => {
	event.preventDefault();
	const inputs = document.querySelectorAll("[data-massive-action='" + target.dataset.massiveToggle + "']");

	const totalCount = inputs.length;
	let activeCount = 0;
	for (const element of inputs) {
		if (element.checked) {
			activeCount += 1;
		}
	}

	const desiredState = activeCount <= totalCount / 2;

	for (const element of inputs) {
		element.checked = desiredState;
	}

	updateMassive(target.dataset.massiveToggle);
});

document.addEventSelectorListener("click", "[data-massive-action]", (event, target) => {
	if (target.checked && event.shiftKey) {
		const inputs = Array.from(document.querySelectorAll("[data-massive-action='" + target.dataset.massiveAction + "']"));

		let isAnyTopChecked = false;
		for (const input of inputs) {
			if (input == target) {
				break;
			}
			else if (input.checked) {
				isAnyTopChecked = true;
				break;
			}
		}

		if (isAnyTopChecked) {
			inputs.reverse();

			let isFound = false;
			for (const input of inputs) {
				if (input == target) {
					isFound = true;
				}
				else if (isFound) {
					if (input.checked) {
						break;
					}
					else {
						input.checked = true;
					}
				}
			}
		}
	}

	updateMassive(target.dataset.massiveAction);
});
